import React from "react";
import TonelagGroupsExplorer from "./TonelagGroupsExplorerResearch";
import tonelagData from "./bokmaalets_tonelagspar_with_frequency.json";

export default function TonelagPage() {
  return <TonelagGroupsExplorer data={tonelagData} />;
}